import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
// Contexts
import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
// Utils
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { LISTING_STATE_PENDING_APPROVAL, LISTING_STATE_CLOSED, propTypes } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';

import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
  NO_ACCESS_PAGE_USER_PENDING_APPROVAL,
  NO_ACCESS_PAGE_VIEW_LISTINGS,
} from '../../util/urlHelpers';
import {
  isErrorNoViewingPermission,
  isErrorUserPendingApproval,
  isForbiddenError,
} from '../../util/errors.js';
import { hasPermissionToViewData, isUserAuthorized } from '../../util/userHelpers.js';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import { richText } from '../../util/richText';
import {
  isBookingProcess,
  isPurchaseProcess,
  resolveLatestProcessName,
} from '../../transactions/transaction';

// Global ducks (for Redux actions and thunks)
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/ui.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import Listing from './CustomListing/Listing.js';
// Shared components
import {
  H4,
  Page,
  NamedLink,
  NamedRedirect,
  OrderPanel,Modal,
  LayoutSingleColumn,
} from '../../components';
// Related components and modules
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import NotFoundPage from '../NotFoundPage/NotFoundPage';

import {
  sendInquiry,
  setInitialValues,
  fetchTimeSlots,
  fetchTransactionLineItems,
} from './ListingPage.duck';

import {
  LoadingPage,
  ErrorPage,
  priceData,
  listingImages,
  handleContactUser,
  handleSubmitInquiry,
  handleSubmit,
  priceForSchemaMaybe,
} from './ListingPage.shared';
import ActionBarMaybe from './ActionBarMaybe';
import SectionTextMaybe from './SectionTextMaybe';
import SectionReviews from './SectionReviews';
import SectionAuthorMaybe from './SectionAuthorMaybe';
import SectionMapMaybe from './SectionMapMaybe';
import SectionGallery from './SectionGallery';

import css from './ListingPage.module.css';
import OrderForm from './CustomListing/OrderForm.js';
import { listingFields } from '../../config/configListing.js';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';

const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;

const { UUID } = sdkTypes;

export const ListingPageComponent = props => {
  const [inquiryModalOpen, setInquiryModalOpen] = useState(
    props.inquiryModalOpenForListingId === props.params.id
  );
  const [orderModalOpen, setOrderModalOpen] = useState(false);

  const [mounted, setMounted] = useState(false);
  const [choosedService, setChoosedService] = useState('')

  useEffect(() => {
    setMounted(true);
  }, []);

  const {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    intl,
    onManageDisableScrolling,
    params: rawParams,
    location,
    scrollingDisabled,
    showListingError,
    reviews = [],
    fetchReviewsError,
    sendInquiryInProgress,
    sendInquiryError,
    monthlyTimeSlots,
    onFetchTimeSlots,
    onFetchTransactionLineItems,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    history,
    callSetInitialValues,
    onSendInquiry, onInquireRushDelivery,
    onInitializeCardPaymentData,
    config,
    routeConfiguration,
    showOwnListingsOnly,  initiatePrivilegedInProgress,
    initiatePrivilegedError,
    initiatePrivileged,updateInProgress,updateProfileError,onUpdateUserPrivateData,
    services, fetchServicesError, onFetchServices
  } = props;
console.log("services",services)
  const listingFields = config.listing.listingFields
  console.log(listingFields,"ListingFields")
  
  const listingId = new UUID(rawParams.id);
  const isVariant = rawParams.variant != null;

  const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
  const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
  const currentListing =
    isPendingApprovalVariant || isDraftVariant || showOwnListingsOnly
      ? ensureOwnListing(getOwnListing(listingId))
      : ensureListing(getListing(listingId));

  const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
  const params = { slug: listingSlug, ...rawParams };

  const listingPathParamType = isDraftVariant
    ? LISTING_PAGE_PARAM_TYPE_DRAFT
    : LISTING_PAGE_PARAM_TYPE_EDIT;
  const listingTab = isDraftVariant ? 'photos' : 'details';

  const isApproved =
    currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;

  const pendingIsApproved = isPendingApprovalVariant && isApproved;

  // If a /pending-approval URL is shared, the UI requires
  // authentication and attempts to fetch the listing from own
  // listings. This will fail with 403 Forbidden if the author is
  // another user. We use this information to try to fetch the
  // public listing.
  const pendingOtherUsersListing =
    (isPendingApprovalVariant || isDraftVariant) &&
    showListingError &&
    showListingError.status === 403;
  const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;

  if (shouldShowPublicListingPage) {
    return <NamedRedirect name="ListingPage" params={params} search={location.search} />;
  }

  const topbar = <TopbarContainer />;

  if (showListingError && showListingError.status === 404) {
    // 404 listing not found
    return <NotFoundPage staticContext={props.staticContext} />;
  } else if (showListingError) {
    // Other error in fetching listing
    return <ErrorPage topbar={topbar} scrollingDisabled={scrollingDisabled} intl={intl} />;
  } else if (!currentListing.id) {
    // Still loading the listing
    return <LoadingPage topbar={topbar} scrollingDisabled={scrollingDisabled} intl={intl} />;
  }

  const {
    description = '',
    geolocation = null,
    price = null,
    title = '',
    publicData = {},
    metadata = {},
  } = currentListing.attributes;
console.log(currentListing.attributes.publicData,"attribute")
  const richTitle = (
    <span>
      {richText(title, {
        longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
        longWordClass: css.longWord,
      })}
    </span>
  );

  const serviceAvailability = currentListing?.attributes?.publicData?.serviceAvailability || [];
  console.log(serviceAvailability, "jdbxfejkw");
    const authorAvailable = currentListing && currentListing.author;
  const userAndListingAuthorAvailable = !!(currentUser && authorAvailable);
  const isOwnListing =
    userAndListingAuthorAvailable && currentListing.author.id.uuid === currentUser.id.uuid;

const prices = services.map(service => ({
  id: service.id,
  service: service.label, 
  amount: service.amount,
}));

console.log(prices, "prices");
console.log(services,"Services")

const availableServices = services.filter(service => serviceAvailability.includes(service.id));

console.log(availableServices, "availableServices");


    const priceSetServices = prices.map(p => p.service.trim());
    console.log(priceSetServices,"priceSetServices")
    // const filteredServices = services.filter(s => priceSetServices.includes(s.service));
    const filteredServices = services.filter(s => priceSetServices.includes(s.label.trim()));
    
    console.log(filteredServices,"filteredservices")

    const servicesWithAmount = availableServices.map(s => {
      console.log('SDFGDDF', s)

      const { id,mandatory,isRushDelivery} = s;
      const priceObject = prices.find(price => price.id === id);
      console.log(priceObject, "priceObject");
      const updatedDeliveryWithin24Hours = !isRushDelivery;
      return {
          id,
          title: s.label,
          amount: priceObject?.amount||0,
          mandatory,
          deliveryWithin24Hours: updatedDeliveryWithin24Hours,
          isRushDelivery:isRushDelivery
      };
  });
  console.log(servicesWithAmount, "servicesWithAmount");

  const categoryConfig=listingFields.filter (f => f.key === 'categories')[0];

  console.log( categoryConfig,"categoryConfig")
const servicesWithAmountAndDes = servicesWithAmount.map(swa => {
    const filteredOption = services.find(optn => optn.id === swa.id);
    return {
        ...swa,
        description: filteredOption ? filteredOption.description : '',
        validity: filteredOption?.validity|| 0,isRushDelivery:filteredOption?.isRushDelivery
    };
});
console.log(servicesWithAmountAndDes,"servicesWithAmountAndDes")
const currentAuthor = authorAvailable ? currentListing.author : null;
const ensuredAuthor = ensureUser(currentAuthor);
const { isRushDelivery } = ensuredAuthor.attributes.profile.publicData;


isRushDelivery && servicesWithAmountAndDes.splice(1, 0, rushDeliveryService);
const savedMessage = currentUser?.attributes?.profile?.privateData?.savedMessage;
    const savedMessageMaybe = savedMessage ? { message: savedMessage } : {};
  const { listingType, transactionProcessAlias, unitType } = publicData;
  if (!(listingType && transactionProcessAlias && unitType)) {
    // Listing should always contain listingType, transactionProcessAlias and unitType)
    return (
      <ErrorPage topbar={topbar} scrollingDisabled={scrollingDisabled} intl={intl} invalidListing />
    );
  }
  const processName = resolveLatestProcessName(transactionProcessAlias.split('/')[0]);
  const isBooking = isBookingProcess(processName);
  const isPurchase = isPurchaseProcess(processName);
  const processType = isBooking ? 'booking' : isPurchase ? 'purchase' : 'inquiry';



  const noPayoutDetailsSetWithOwnListing =
    isOwnListing && (processType !== 'inquiry' && !currentUser?.attributes?.stripeConnected);
  const payoutDetailsWarning = noPayoutDetailsSetWithOwnListing ? (
    <span className={css.payoutDetailsWarning}>
      <FormattedMessage id="ListingPage.payoutDetailsWarning" values={{ processType }} />
      <NamedLink name="StripePayoutPage">
        <FormattedMessage id="ListingPage.payoutDetailsWarningLink" />
      </NamedLink>
    </span>
  ) : null;

  // When user is banned or deleted the listing is also deleted.
  // Because listing can be never showed with banned or deleted user we don't have to provide
  // banned or deleted display names for the function
  const authorDisplayName = userDisplayNameAsString(ensuredAuthor, '');

  const { formattedPrice } = priceData(price, config.currency, intl);

  const commonParams = { params, history, routes: routeConfiguration };
  const onContactUser = handleContactUser({
    ...commonParams,
    currentUser,
    callSetInitialValues,
    location,
    setInitialValues,
    setInquiryModalOpen,
  });
  // Note: this is for inquiry state in booking and purchase processes. Inquiry process is handled through handleSubmit.
  const onSubmitInquiry = handleSubmitInquiry({
    ...commonParams,
    getListing,
    onSendInquiry,
    setInquiryModalOpen,
    onUpdateUserPrivateData
  });
  const onSubmit = handleSubmit({
    ...commonParams,
    currentUser,
    callSetInitialValues,
    getListing,
    onInitializeCardPaymentData,
  });

  // const handleOrderSubmit = values => {
  //   const isCurrentlyClosed = currentListing.attributes.state === LISTING_STATE_CLOSED;
  //   if (isOwnListing || isCurrentlyClosed) {
  //     window.scrollTo(0, 0);
  //   } else {
  //     console.log(values,"valufeewdses")
  //     onSubmit(values);
  //   }
  // };
  const handleOrderSubmit = async (values) => {
    const isCurrentlyClosed = currentListing.attributes.state === LISTING_STATE_CLOSED;
    if (isOwnListing || isCurrentlyClosed) {
        window.scrollTo(0, 0);
    } else {
        //Existence of booking date depends upon service 
        //however, for future possibilities we are taking
        //date but will not consider it right now for 
        //our logic, it is just of no use right now

        const { saveMessage, service, message, images, bookingStartDate = new Date() } = values;
        console.log('valuesLP', values)
        const bookingDates = { startDate: bookingStartDate, endDate: bookingStartDate };
console.log(' defg',  service)
        //Determine if the service is deliverable within 24 hours
        const quantity = 1;
        const selectedService = servicesWithAmountAndDes.find(s => s.id === service);
        const deliveryWithin24Hours = selectedService && selectedService.isRushDelivery === false;
        //see, if user has chose for upsell or not
        const orderData = { bookingDates, service, message, images,deliveryWithin24Hours,
          amount: selectedService.amount,
          validity: selectedService.validity,
          description: selectedService.description,
          quantity,
        };
        console.log('orderData', orderData)
        //save or update message if required.
        if (isAuthenticated && saveMessage && saveMessage.length > 0) {
            const updateRes = await onUpdateUserPrivateData({ privateData: { savedMessage: message } });
            if (updateRes && updateRes.status === 200) {
                return onSubmit(orderData);
            }
        } else {
            onSubmit(orderData)
        }
    }
};

  const facebookImages = listingImages(currentListing, 'facebook');
  const twitterImages = listingImages(currentListing, 'twitter');
  const schemaImages = listingImages(
    currentListing,
    `${config.layout.listingImage.variantPrefix}-2x`
  ).map(img => img.url);
  const marketplaceName = config.marketplaceName;
  const schemaTitle = intl.formatMessage(
    { id: 'ListingPage.schemaTitle' },
    { title, price: formattedPrice, marketplaceName }
  );
  // You could add reviews, sku, etc. into page schema
  // Read more about product schema
  // https://developers.google.com/search/docs/advanced/structured-data/product
  const productURL = `${config.marketplaceRootURL}${location.pathname}${location.search}${location.hash}`;
  const currentStock = currentListing.currentStock?.attributes?.quantity || 0;
  const schemaAvailability = !currentListing.currentStock
    ? null
    : currentStock > 0
    ? 'https://schema.org/InStock'
    : 'https://schema.org/OutOfStock';

  const availabilityMaybe = schemaAvailability ? { availability: schemaAvailability } : {};

  const handleOnOrder = (service) => {

    if (!isOwnListing) {
        setChoosedService(service)
        setOrderModalOpen(true)
    } else {
        window.scrollTo(0, 0)
    }
}

  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      author={authorDisplayName}
      description={description}
      facebookImages={facebookImages}
      twitterImages={twitterImages}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Product',
        description: description,
        name: schemaTitle,
        image: schemaImages,
        offers: {
          '@type': 'Offer',
          url: productURL,
          ...priceForSchemaMaybe(price),
          ...availabilityMaybe,
        },
      }}
    >
      <LayoutSingleColumn className={css.pageRoot} topbar={topbar} footer={<FooterContainer />}>
            {mounted && currentListing.id && noPayoutDetailsSetWithOwnListing ? (
              <ActionBarMaybe
                className={css.actionBarForProductLayout}
                isOwnListing={isOwnListing}
                listing={currentListing}
                showNoPayoutDetailsSet={noPayoutDetailsSetWithOwnListing}
                currentUser={currentUser}
              />
            ) : null}
            {mounted && currentListing.id ? (
              <ActionBarMaybe
                className={css.actionBar}
                isOwnListing={isOwnListing}
                listing={currentListing}
                currentUser={currentUser}
                editParams={{
                  id: listingId.uuid,
                  slug: listingSlug,
                  type: listingPathParamType,
                  tab: listingTab,
                }}
              />
            ) : null}
      <div className={css.root}>
      <div className={css.leftSide}>
    <SectionAuthorMaybe
              title={title}
              listing={currentListing}
              authorDisplayName={authorDisplayName}
              onContactUser={onContactUser}
              isInquiryModalOpen={isAuthenticated && inquiryModalOpen}
              onCloseInquiryModal={() => setInquiryModalOpen(false)}
              onChooseReading={() => setOrderModalOpen(true)}
              initialValues={{ ...savedMessageMaybe }}
              sendInquiryError={sendInquiryError}
              sendInquiryInProgress={sendInquiryInProgress}
              onSubmitInquiry={onSubmitInquiry}
              currentUser={currentUser}
              onManageDisableScrolling={onManageDisableScrolling}
              updateInProgress={updateInProgress}
              updateProfileError={updateProfileError}
              />
                    </div>
                    <div className={css.listingBox}>
          <Listing
    intl={intl}
    listing={currentListing}
    currentUser={currentUser}
    servicesWithAmountAndDes={servicesWithAmountAndDes}
    onOrder={handleOnOrder}  // Ensure selected service is handled correctly
    reviews={reviews}
    fetchReviewsError={fetchLineItemsError}
    listingFieldsInProgress={null}
    listingFieldsError={null}
    authorDisplayName={authorDisplayName}
    onInquireRushDelivery={onInquireRushDelivery}  // Handle rush logic
    isOwnListing={isOwnListing}
    initiatePrivilegedInProgress={initiatePrivilegedInProgress}
    initiatePrivilegedError={initiatePrivilegedError}
    initiatePrivileged={initiatePrivileged}  
/>      </div>
          </div>
        <Modal id="ListingPage.order" isOpen={orderModalOpen} onClose={() => setOrderModalOpen(false)} onManageDisableScrolling={onManageDisableScrolling}>
                    <OrderForm intl={intl}
                    services={services}
                    prices={prices}
                        onSubmit={handleOrderSubmit}
                        authorDisplayName={authorDisplayName}
                        onFetchTransactionLineItems={onFetchTransactionLineItems}
                        isOwnListing={isOwnListing}
                        listingId={listingId}
                        listing={currentListing}
                        monthlyTimeSlots={monthlyTimeSlots}
                        onFetchTimeSlots={onFetchTimeSlots}
                        lineItems={lineItems}
                        fetchLineItemsError={fetchLineItemsError}
                        fetchLineItemsInProgress={fetchLineItemsInProgress}
                        marketplaceCurrency={config.currency}
                        dayCountAvailableForBooking={config.stripe.dayCountAvailableForBooking}
                        marketplaceName={config.marketplaceName}
                        initialValues={{ service: choosedService, ...savedMessageMaybe }}
                        currentUser={currentUser}
                        messageAlreadySaved={!!savedMessage}
                        updateInProgress={updateInProgress}
                        updateProfileError={updateProfileError}
                        isRushDelivery={isRushDelivery}
                    />
                </Modal>
      </LayoutSingleColumn>
    </Page>
  );
};

/**
 * The ListingPage component with carousel layout.
 *
 * @component
 * @param {Object} props
 * @param {Object} props.params - The path params object
 * @param {string} props.params.id - The listing id
 * @param {string} props.params.slug - The listing slug
 * @param {LISTING_PAGE_DRAFT_VARIANT | LISTING_PAGE_PENDING_APPROVAL_VARIANT} props.params.variant - The listing variant
 * @param {Function} props.onManageDisableScrolling - The on manage disable scrolling function
 * @param {boolean} props.isAuthenticated - Whether the user is authenticated
 * @param {Function} props.getListing - The get listing function
 * @param {Function} props.getOwnListing - The get own listing function
 * @param {Object} props.currentUser - The current user
 * @param {boolean} props.scrollingDisabled - Whether scrolling is disabled
 * @param {string} props.inquiryModalOpenForListingId - The inquiry modal open for the specific listing id
 * @param {propTypes.error} props.showListingError - The show listing error
 * @param {Function} props.callSetInitialValues - The call setInitialValues function, which is given to this function as a parameter
 * @param {Array<propTypes.review>} props.reviews - The reviews
 * @param {propTypes.error} props.fetchReviewsError - The fetch reviews error
 * @param {Object<string, Object>} props.monthlyTimeSlots - The monthly time slots. E.g. { '2019-11': { timeSlots: [], fetchTimeSlotsInProgress: false, fetchTimeSlotsError: null } }
 * @param {boolean} props.sendInquiryInProgress - Whether the send inquiry is in progress
 * @param {propTypes.error} props.sendInquiryError - The send inquiry error
 * @param {Function} props.onSendInquiry - The on send inquiry function
 * @param {Function} props.onInitializeCardPaymentData - The on initialize card payment data function
 * @param {Function} props.onFetchTimeSlots - The on fetch time slots function
 * @param {Function} props.onFetchTransactionLineItems - The on fetch transaction line items function
 * @param {Array<propTypes.transactionLineItem>} props.lineItems - The line items
 * @param {boolean} props.fetchLineItemsInProgress - Whether the fetch line items is in progress
 * @param {propTypes.error} props.fetchLineItemsError - The fetch line items error
 * @returns {JSX.Element} listing page component
 */
const EnhancedListingPage = props => {
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();

  const showListingError = props.showListingError;
  const isVariant = props.params?.variant != null;
  const currentUser = props.currentUser;
  if (isForbiddenError(showListingError) && !isVariant && !currentUser) {
    // This can happen if private marketplace mode is active
    return (
      <NamedRedirect
        name="SignupPage"
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }

  const isPrivateMarketplace = config.accessControl.marketplace.private === true;
  const isUnauthorizedUser = currentUser && !isUserAuthorized(currentUser);
  const hasNoViewingRights = currentUser && !hasPermissionToViewData(currentUser);
  const hasUserPendingApprovalError = isErrorUserPendingApproval(showListingError);

  if ((isPrivateMarketplace && isUnauthorizedUser) || hasUserPendingApprovalError) {
    return (
      <NamedRedirect
        name="NoAccessPage"
        params={{ missingAccessRight: NO_ACCESS_PAGE_USER_PENDING_APPROVAL }}
      />
    );
  } else if (
    (hasNoViewingRights && isForbiddenError(showListingError)) ||
    isErrorNoViewingPermission(showListingError)
  ) {
    // If the user has no viewing rights, fetching anything but their own listings
    // will return a 403 error. If that happens, redirect to NoAccessPage.
    return (
      <NamedRedirect
        name="NoAccessPage"
        params={{ missingAccessRight: NO_ACCESS_PAGE_VIEW_LISTINGS }}
      />
    );
  }

  return (
    <ListingPageComponent
      config={config}
      routeConfiguration={routeConfiguration}
      intl={intl}
      history={history}
      location={location}
      showOwnListingsOnly={hasNoViewingRights}
      {...props}
    />
  );
};

const mapStateToProps = state => {
  const { updateInProgress, updateProfileError } = state.ProfileSettingsPage;
  const { isAuthenticated } = state.auth;
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    sendInquiryInProgress,
    sendInquiryError,
    lineItems,
    fetchLineItemsInProgress,
    initiatePrivilegedInProgress,
    initiatePrivilegedError,initiatePrivileged,
    fetchLineItemsError,
    inquiryModalOpenForListingId, services, 
    fetchServicesInProgress, 
    fetchServicesError
  } = state.ListingPage;
  const { currentUser } = state.user;


  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  return {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    inquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendInquiryInProgress,
    sendInquiryError,initiatePrivilegedInProgress,
    initiatePrivilegedError,
    initiatePrivileged,
    updateInProgress,
    updateProfileError,services,                 
    fetchServicesInProgress,   
    fetchServicesError,        
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onFetchTransactionLineItems: params => dispatch(fetchTransactionLineItems(params)),
  onSendInquiry: (listing, message) => dispatch(sendInquiry(listing, message)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  onFetchTimeSlots: (listingId, start, end, timeZone) =>
    dispatch(fetchTimeSlots(listingId, start, end, timeZone)),
  onInquireRushDelivery: (listing) => dispatch(inquireRushDelivery(listing)),
  onFetchServices: () => dispatch(fetchServicesThunk()), // <-- Add this line
  onUpdateUserPrivateData: (data) => dispatch(updateProfile(data)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(EnhancedListingPage);

export default ListingPage;
